import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './Notifications';
import { NotificationQueueState } from './redux/types';
import { removeNotification } from './redux/actionCreators';
import { getNotificationQueue } from './redux/selectors';

export type StateProps = Pick<Props, 'queue'>;
export type DispatchProps = Pick<Props, 'removeNotification'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (
  state: NotificationQueueState,
  ownProps
): StateProps => ({
  queue: getNotificationQueue(state, ownProps.queueName),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  removeNotification,
};

export default connect(mapStateToProps, mapDispatchToProps);
